/** Monotonic id for CSS badge tooltips (works with renderToStaticMarkup). */
let seq = 0;

export default function nextBadgeTooltipId(prefix) {
  seq += 1;
  return `${prefix}-${seq}`;
}
